/**
 * Agency Settings service - per-agency integration management.
 *
 * Currently handles the Gmail API OAuth connection used for outreach.
 */

import { apiClient } from "@/services/apiClient";

export interface GmailCredentialSummary {
  id: string;
  emailAddress: string;
  displayName: string | null;
  connectedAt: string | null;
  lastUsedAt: string | null;
  revokedAt: string | null;
  scopes: string[];
}

export interface GmailStatusResponse {
  connected: boolean;
  oauthConfigured: boolean;
  credential: GmailCredentialSummary | null;
}

interface ConnectResponse {
  success: boolean;
  authUrl?: string;
  error?: string;
}

interface DisconnectResponse {
  success: boolean;
}

export const agencySettingsService = {
  async getGmailStatus(): Promise<GmailStatusResponse> {
    return apiClient.get<GmailStatusResponse>("/api/integrations/gmail/status");
  },

  async startGmailConnect(): Promise<string> {
    const resp = await apiClient.get<ConnectResponse>(
      "/api/integrations/gmail/connect"
    );
    if (!resp.success || !resp.authUrl) {
      throw new Error(resp.error || "Failed to start Gmail OAuth flow");
    }
    return resp.authUrl;
  },

  async disconnectGmail(): Promise<void> {
    await apiClient.post<DisconnectResponse>(
      "/api/integrations/gmail/disconnect",
      {}
    );
  },
};
